import Vue from "vue";
import Vuetify, { colors } from "vuetify/lib";

// Editor plugin
import { TiptapVuetifyPlugin } from "tiptap-vuetify";
import "tiptap-vuetify/dist/main.css";
import EyesClosedIcon from "../components/icons/EyesClosedIcon.vue";
import CaretUpIcon from "../components/icons/CaretUpIcon.vue";
import GeneralIcon from "../components/icons/GeneralIcon.vue";
import GestionUserIcon from "../components/icons/GestionUserIcon.vue";
import InformationIcon from "../components/icons/InformationIcon.vue";
import MarketingIcon from "../components/icons/MarketingIcon.vue";
import SpotsIcon from "../components/icons/SpotsIcon.vue";
import SettingIcon from "../components/icons/SettingIcon.vue";
import ReservasIcon from "../components/icons/ReservasIcon.vue";
import FinanzasIcon from "../components/icons/FinanzasIcon.vue";
import CoinsIcon from "../components/icons/CoinsIcon.vue";
import ClockCounterIcon from "../components/icons/ClockCounterIcon.vue";
import CalendarIcon from "../components/icons/CalendarIcon.vue";
import DownloadIcon from "../components/icons/DownloadIcon.vue";
import EditIcon from "../components/icons/EditIcon.vue";
import DeleteIcon from "../components/icons/DeleteIcon.vue";
import BellIcon from "../components/icons/bellIcon.vue";
import ArrowLeftIcon from "../components/icons/arrowLeftIcon.vue";
import ArrowRightIcon from "../components/icons/arrowRightIcon.vue";
import PlusIcon from "../components/icons/plusIcon.vue";
import ChevronLeftIcon from "../components/icons/ChevronLeftIcon.vue";
import ChevronRightIcon from "../components/icons/ChevronRightIcon.vue";
import ChevronDownIcon from "../components/icons/ChevronDownIcon.vue";
import ChevronUpIcon from "../components/icons/ChevronUpIcon.vue";
import CameraIcon from "../components/icons/CameraIcon.vue";
import CaretDownFormIcon from "../components/icons/CaretDownFormIcon.vue";
import CaretDownUpIcon from "../components/icons/CaretDownUpIcon.vue";
import PercentIcon from "../components/icons/PercentIcon.vue";
import FilePngIcon from "../components/icons/FilePngIcon.vue";
import CircleCheckIcon from "../components/icons/CircleCheckIcon.vue";
import CheckedIcon from "../components/icons/CheckedIcon.vue";
import UnCheckedIcon from "../components/icons/UnCheckedIcon.vue";
import UploadDropIcon from "../components/icons/UploadDropIcon.vue";
import CloseIcon from "../components/icons/closeIcon.vue";
import CaretDownIcon from "../components/icons/CaretDownIcon.vue";
// Importa tus variables antes de Vuetify
//import "@/assets/css/variables.scss"; 
// Importar Vuetify desde SCSS para que use tus variables
//import "vuetify/src/styles/styles.sass";

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    light: false,
    options: {
      customProperties: true, // genera variables CSS (--v-theme-*)
    },
    themes: {
      light: {
        primary: {
          base:"#191919",
          light: "red",
          dark: "#419C4E",
        },
        lightPrimary: "#F7F7F7",
        purpleLight: "#F2EAFC",
        purple: "#8A36C6",
        grayLight:"#353535",
        grayVibrant: "#404040",
        redLight: "#FF3B30",
        greenDark: "#054A1B",
        secondary: "#159941",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
      },
      dark: {
        primary: "white",
        secondary: "#159941",
      },
    },
  },
  preset: {
    VTextField: {
      outlined: true,
      dense: true,
      hideDetails: "auto",
      clearable: false,
    },
  },
  icons: {
    iconfont: "fa",
    values: {
      eyesClosed: { component: EyesClosedIcon },
      caretUp: { component: CaretUpIcon },
      generalIcon: { component: GeneralIcon },
      gestionUserIcon: { component: GestionUserIcon},
      infoIcon: { component: InformationIcon},
      marketingIcon: { component: MarketingIcon},
      rentIcon: { component: ReservasIcon },
      spotsIcon: { component: SpotsIcon },
      configIcon: { component: SettingIcon },
      financesIcon: { component: FinanzasIcon },
      coinsIcon: { component: CoinsIcon },
      clockCounterIcon: { component: ClockCounterIcon },
      calendarIcon: { component: CalendarIcon },
      downloadIcon: { component: DownloadIcon },
      editIcon: { component: EditIcon },
      deleteIcon: { component: DeleteIcon },
      bellIcon: { component: BellIcon },
      arrowLeftIcon: { component: ArrowLeftIcon },
      arrowRightIcon: { component: ArrowRightIcon },
      plusIcon: { component: PlusIcon },
      chevronLeftIcon: { component: ChevronLeftIcon },
      chevronRightIcon: { component: ChevronRightIcon },
      chevronDownIcon: { component: ChevronDownIcon },
      chevronUpIcon: { component: ChevronUpIcon },
      cameraIcon: { component: CameraIcon },
      caretDownFormIcon: { component: CaretDownFormIcon },
      caretDownUpIcon: { component: CaretDownUpIcon },
      percentIcon: { component: PercentIcon },
      filePngIcon: { component: FilePngIcon },
      circleCheckIcon: { component: CircleCheckIcon },
      checkedIcon: { component: CheckedIcon },
      unCheckedIcon: { component: UnCheckedIcon },
      uploadDropIcon: { component: UploadDropIcon },
      closeIcon: { component: CloseIcon },
      caretDownIcon: { component: CaretDownIcon },
    },
  },
});

Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: "fa",
});

export default vuetify;
